import { resolveAuthDomain } from "@internal/supabase-client";

export function getHubUrl(path: string): string {
  if (typeof window === "undefined") {
    throw new Error("getHubUrl requires a browser environment");
  }
  const rootDomain = resolveAuthDomain(window.location.hostname);
  const port = window.location.port ? `:${window.location.port}` : "";
  return `${window.location.protocol}//konto.${rootDomain}${port}${path}`;
}

export function redirectToHubLogin(): void {
  if (typeof window === "undefined") return;
  const next = encodeURIComponent(window.location.href);
  window.location.assign(getHubUrl(`/login?next=${next}`));
}
